module.exports = __webpack_public_path__ + "img/合作保险公司.71862362.png";